<template>
  <div class="desktop-notice" aria-live="polite">
    <div class="desktop-notice-card">
      <img src="@/assets/images/logo.png" class="desktop-notice-logo" alt="Logo" />
      <div class="desktop-notice-icon" aria-hidden="true">
        <svg viewBox="0 0 64 64" width="72" height="72" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="18" y="6" width="28" height="52" rx="6" stroke="rgba(24,171,63,1)" stroke-width="3" />
          <circle cx="32" cy="50" r="2.5" fill="rgba(24,171,63,1)" />
          <path d="M26 12h12" stroke="rgba(24,171,63,1)" stroke-width="3" stroke-linecap="round" />
          <path
            d="M46 22c4 3 6 7 6 12s-2 9-6 12"
            stroke="rgba(156,156,156,1)"
            stroke-width="2.5"
            stroke-linecap="round"
          />
          <path
            d="M51 18c6 4 9 10 9 16s-3 12-9 16"
            stroke="rgba(120,120,120,1)"
            stroke-width="2.5"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <h1 class="desktop-notice-title">Otvorite na mobilnom uređaju</h1>
      <p class="desktop-notice-text">
        Ova aplikacija je prilagođena za mobilni prikaz.<br />
        Molimo Vas da je otvorite na telefonu ili smanjite prozor pregledača.
      </p>
    </div>
  </div>

  <div class="mobile-app">
    <div v-if="this.currentRoute.includes('scan')">
      <router-view />
    </div>
    <template v-else>
      <div class="logo">
        <img src="@/assets/images/arrow.png" class="arrow" alt="Nazad" v-if="!showButtons" @click="registrationScreen()" />
        <img src="@/assets/images/logo.png" class="logo-img" alt="Logo" />
      </div>
      <div class="container" v-if="showButtons">
        <div class="row buttons">
          <div class="col-xs-6">
            <button :class="{ btnAccess: screenMode == 1, btnAccessInactive: screenMode == 2 }" @click="switchScreen()">Registracija</button>
          </div>
          <div class="col-xs-6">
            <button :class="{ btnAccess: screenMode == 2, btnAccessInactive: screenMode == 1 }" @click="switchScreen()">Prijava</button>
          </div>
        </div>
      </div>
      <router-view />
    </template>
  </div>
</template>
<script>
import store from "@/store";
import { Vue } from "vue-class-component";

export default class App extends Vue {
  screenMode = 1; //1 - registracija, 2 - logovanje
  currentRoute = "";
  showButtons = true;
  incodeModeListener = () => this.updateCurrentRoute();
  created() {
    store.commit("SET_HIDE_AUTH_TOGGLE_BUTTONS", false);
    this.updateCurrentRoute();
  }
  mounted() {
    this.$watch("$route", () => this.updateCurrentRoute());
    this.$watch(() => store.state.hideAuthToggleButtons, () => this.updateCurrentRoute());
    window.addEventListener("incode-validation-mode-changed", this.incodeModeListener);
    this.$nextTick(() => this.updateCurrentRoute());
  }
  unmounted() {
    window.removeEventListener("incode-validation-mode-changed", this.incodeModeListener);
  }
  updateCurrentRoute() {
    const fullPath = this.$route?.fullPath;
    if (!fullPath) {
      return;
    }

    this.currentRoute = fullPath;
    this.syncAuthTokensFromQuery();
    this.currentRoute.includes("login") ? (this.screenMode = 2) : (this.screenMode = 1);

    const hideByOtpStep = Boolean(store.state.hideAuthToggleButtons);
    const hideByRoute =
      this.currentRoute.includes("password") || this.currentRoute.includes("auth-successful");
    this.showButtons = !hideByRoute && !hideByOtpStep;
  }
  syncAuthTokensFromQuery() {
    const query = this.$route?.query;
    if (!query) {
      return;
    }

    const tokenQuery = query.token;
    const tokenValue = Array.isArray(tokenQuery) ? tokenQuery[0] : tokenQuery;
    if (tokenValue && String(tokenValue).trim() !== "") {
      const normalizedToken = String(tokenValue);
      store.commit("SET_TOKEN", normalizedToken);
      localStorage.setItem("token", JSON.stringify(normalizedToken));
    }

    const authorizationTokenQuery = query.authorizationToken;
    const authorizationTokenValue = Array.isArray(authorizationTokenQuery)
      ? authorizationTokenQuery[0]
      : authorizationTokenQuery;
    if (authorizationTokenValue && String(authorizationTokenValue).trim() !== "") {
      const normalizedAuthorizationToken = String(authorizationTokenValue);
      store.commit("SET_AUTHORIZATION_TOKEN", normalizedAuthorizationToken);
      sessionStorage.setItem("loyaltyAuthorizationToken", normalizedAuthorizationToken);
    }
  }
  switchScreen() {
    if (this.screenMode == 1) {
      this.screenMode = 2;
      this.$router.push("/login");
    } else {
      this.screenMode = 1;
      this.$router.push("/starthere");
    }
  }

  registrationScreen() {
    const backEvent = new CustomEvent("registration-back-requested", { cancelable: true });
    window.dispatchEvent(backEvent);
    if (backEvent.defaultPrevented) {
      return;
    }
    if (this.currentRoute.includes("forgot-password")) {
      this.$router.push("/login");
      return;
    }
    store.commit("SET_HIDE_AUTH_TOGGLE_BUTTONS", false);
    this.updateCurrentRoute();
    this.$router.push("/starthere");
  }
}
</script>
<style>
input,
button {
  border: none;
  outline: none;
  box-shadow: none;
}

body {
  display: block !important;
  background: rgba(24, 24, 24, 1);
  font-family: "Saira", sans-serif;
  margin: 0;
  min-height: 100vh;
}

.mobile-app {
  display: none;
}

.desktop-notice {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 32px 20px;
  background:
    radial-gradient(ellipse at top, rgba(24, 171, 63, 0.12), transparent 55%),
    rgba(24, 24, 24, 1);
}

.desktop-notice-card {
  width: 100%;
  max-width: 460px;
  text-align: center;
  padding: 40px 36px;
  border-radius: 16px;
  background: rgba(35, 35, 35, 1);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.35);
}

.desktop-notice-logo {
  width: 180px;
  max-width: 70%;
  height: auto;
  margin-bottom: 28px;
}

.desktop-notice-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.desktop-notice-title {
  margin: 0 0 12px;
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.25;
}

.desktop-notice-text {
  margin: 0;
  color: rgba(156, 156, 156, 1);
  font-size: 16px;
  line-height: 1.55;
  font-weight: 400;
}

@media (max-width: 480px) {
  .desktop-notice {
    display: none;
  }

  .mobile-app {
    display: block;
  }

  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .logo .logo-img {
    width: 200px;
    max-width: 100%;
    height: auto;
    margin-bottom: 20px;
    margin-top: 30px;
  }
  .btnAccess {
    text-align: center;
    text-transform: uppercase;
    width: 100%;
    height: 50px !important;
    border-radius: 8px !important;
    margin-top: 5px;
    margin-bottom: 5px;
    color: white !important;
    background: rgba(24, 171, 63, 1) !important;

    box-shadow: 0px 7px 14px 0px rgba(255, 255, 255, 0.27) inset;

    box-shadow: 0px -6px 11px 0px rgba(0, 0, 0, 0.3) inset;
  }

  .btnAccessInactive {
    text-transform: uppercase;

    background: none;
    width: 100%;
    text-align: center;
    color: white;
  }
  .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    margin: 0 auto;
    background: rgba(35, 35, 35, 1);
    border-radius: 5px;
    width: 326px;
    margin-bottom: 20px;
  }

  .arrow {
    width: 35px;
    position: absolute;
    left: 40px;
  }
}
</style>
